// extracted by mini-css-extract-plugin
export default {"container":"ContentLabel_container__SY6rm","left_container":"ContentLabel_left_container__TALSY","right_container":"ContentLabel_right_container__LJp+Z"};